module.exports = __webpack_public_path__ + "media/sub7-6-2.acc7e452.mp4";